module.exports = __webpack_public_path__ + "static/media/prvcuLogo.32fe2ebe.jpg";